export default __webpack_public_path__ + "static/image4-icon-36e069af5a024d6028a11cca3a15080c.png";